var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMarketingTeachingIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38.002,
    height: 34.142,
    viewBox: "0 0 38.002 34.142",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "footer_1_",
    "data-name": "footer (1)",
    transform: "translate(0 -26.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(0 26.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M35.775,26H2.227A2.229,2.229,0,0,0,0,28.228V57.917a2.229,2.229,0,0,0,2.227,2.227H35.775A2.229,2.229,0,0,0,38,57.917V28.228A2.229,2.229,0,0,0,35.775,26Zm.742,31.916a.743.743,0,0,1-.742.742H2.227a.743.743,0,0,1-.742-.742V28.228a.743.743,0,0,1,.742-.742H35.775a.743.743,0,0,1,.742.742V57.917Z",
    transform: "translate(0 -26.001)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M75.58,331H64a.742.742,0,0,0,0,1.484H74.838v5.2H46.484v-5.2H57.321a.742.742,0,0,0,0-1.484H45.742a.742.742,0,0,0-.742.742v6.68a.742.742,0,0,0,.742.742H75.58a.742.742,0,0,0,.742-.742v-6.68A.742.742,0,0,0,75.58,331Z",
    transform: "translate(-41.66 -308.362)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M75.638,71H45.8a.742.742,0,0,0,0,1.484H75.638A.742.742,0,0,0,75.638,71Z",
    transform: "translate(-41.719 -67.66)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M75.638,157.667H45.8a.742.742,0,0,0,0,1.484H75.638A.742.742,0,0,0,75.638,157.667Z",
    transform: "translate(-41.719 -149.894)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M60.72,201H45.8a.742.742,0,0,0,0,1.484H60.72A.742.742,0,0,0,60.72,201Z",
    transform: "translate(-41.719 -188.011)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M247.483,331.742a.742.742,0,0,0-.742-.742h0a.742.742,0,1,0,.743.742Z",
    transform: "translate(-227.739 -308.362)",
    fill: "#009dd7"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarketingTeachingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/marketing-teaching-icon.13e1a503.svg";
export { ForwardRef as ReactComponent };